import { useState } from 'react';
import type { PresenceStatus } from '@comms/shared';
import { useStore } from '../store';
import { getGateway, logout } from '../lib/session';
import { openModal } from '../store/ui';
import { Avatar, Icon, StatusDot } from './ui';
import { VoiceToggles } from './VoiceUi';

const STATUSES: { id: Exclude<PresenceStatus, 'offline'>; label: string }[] = [
  { id: 'online', label: 'Online' },
  { id: 'idle', label: 'Idle' },
  { id: 'dnd', label: 'Do Not Disturb' },
  { id: 'invisible', label: 'Invisible' },
];

export function UserPanel() {
  const me = useStore((s) => s.me);
  const presence = useStore((s) => (me ? s.presences[me.id] : undefined));
  const [open, setOpen] = useState(false);
  if (!me) return null;
  return (
    <div className="relative flex h-[52px] items-center gap-2 bg-bg-0/60 px-2">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex min-w-0 flex-1 items-center gap-2 rounded p-1 text-left hover:bg-bg-hover"
      >
        <Avatar userId={me.id} size={32} showStatus />
        <span className="min-w-0">
          <span className="block truncate text-sm font-semibold text-text-0">{me.displayName}</span>
          <span className="block truncate text-xs text-text-3">
            {presence?.customStatus ?? me.username}
          </span>
        </span>
      </button>
      <VoiceToggles />
      <button
        type="button"
        title="User settings"
        onClick={() => openModal({ kind: 'userSettings' })}
        className="rounded p-1.5 text-text-2 hover:bg-bg-hover hover:text-text-0"
      >
        <Icon name="settings" />
      </button>
      {open && (
        <div className="absolute bottom-14 left-2 z-30 w-56 rounded bg-bg-0 p-1.5 shadow-xl">
          {STATUSES.map((s) => (
            <button
              key={s.id}
              type="button"
              onClick={() => {
                getGateway()?.setPresence(s.id, presence?.customStatus ?? null);
                setOpen(false);
              }}
              className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-sm text-text-2 hover:bg-accent hover:text-white"
            >
              <StatusDot status={s.id} className="h-2.5 w-2.5" /> {s.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => {
              const text = prompt('Custom status', presence?.customStatus ?? '');
              if (text !== null) {
                const status =
                  presence?.status && presence.status !== 'offline' ? presence.status : 'online';
                getGateway()?.setPresence(status, text.trim() || null);
              }
              setOpen(false);
            }}
            className="mt-1 w-full rounded border-t border-bg-3 px-2 py-1.5 text-left text-sm text-text-2 hover:bg-accent hover:text-white"
          >
            Set custom status
          </button>
          <button
            type="button"
            onClick={() => void logout()}
            className="flex w-full items-center gap-2 rounded px-2 py-1.5 text-sm text-danger hover:bg-danger hover:text-white"
          >
            <Icon name="logout" className="h-4 w-4" /> Log out
          </button>
        </div>
      )}
    </div>
  );
}
